module.exports = __webpack_public_path__ + "img/img-noPermission.5c5c2b1c.png";